import { CONTENT_ALIAS } from './const.config';

// Define page-title configurations
const PAGE_TITLE_LIST = {
  OVERVIEW_DASHBOARD: 'Overview Dashboard',
  ADMIN_USERS: 'Users',
  CONTENT_CHANNELS: 'Content / Channels',
  CONTENT_LANGUAGES: 'Content / Languages',
  CONTENT_CATEGORY: `Content / ${CONTENT_ALIAS.CATEGORY_PLURAL}`,
  CONTENT_VIDEOS: `Content / ${CONTENT_ALIAS.VIDEO_PLURAL}`,
  CONTENT_ADS: 'Content / Ads',
  CONTENT_TABS: 'Content / Tabs',
  CONTENT_RESOURCES: 'Tools / Resources',
  CONTACTS: 'Subscribers',
  BULK_EMAIL: 'Tools / Bulk Email',
  REPORTS_OVERVIEW_VIDEOS: `Analytics Reports / Overview (App)`,
  REPORTS_OVERVIEW_ADS: 'Analytics Reports / Overview (Ads)',
  REPORTS_ENGAGEMENT: 'Analytics Reports / Engagement',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  ERROR_NOT_FOUND: '404 Not Found',
};

export default PAGE_TITLE_LIST;
